import React, { useState, useEffect } from "react";
import { Grid, Button } from "@material-ui/core";
import AutoInputPaises from "../AutoInputPais";
import AutoInputCuidades from "../AutoInputCiudades";
import { FPaquetesStyle } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { ToastMessage } from "../../../global/ToastMessage";
import TablaRegistro from "./TablaRegistro";
import BackDrop from "./../../../global/BackDrop";
import { crearCiudadPaqueteTerrestre, obtenerCiudadesPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck";

const InitialValuePais = {
  IdPais: 0,
  Nombre: "",
  Codigo: "0",
}
const InitialValueCiudad = {
  IdCiudad: 0, 
  Nombre: ""
}

const Destinos = (props) => {
  const dispatch = useDispatch();
  const destinosPaquete = useSelector((state) => state.paquetes.arrayDestinos);
  const { paqueteSelect } = useSelector(store => store.proveedorTerrestre);

  const [pais, setPais] = useState(InitialValuePais);
  const [cuidad, setCuidad] = useState(InitialValueCiudad);
  const classes = FPaquetesStyle();
  const [isLoad, setIsLoad] = useState(false);
  
  useEffect(() => {
    const loadDestinos = async () => {
      setIsLoad(true);
      await dispatch(obtenerCiudadesPaqueteTerrestre({
        idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre,
      }));
      setIsLoad(false);
    };
  
    loadDestinos();
  }, [paqueteSelect.IdPaqueteProveedorTerrestre, dispatch]);

  const onGuardar = () => {
    if (pais.IdPais > 0 && cuidad.IdCiudad > 0) {
      if (!destinosPaquete.find(destino => destino.IdCiudad === cuidad.IdCiudad)){
        setIsLoad(true);
        let payload = {
          idPaqueteTerrestre: paqueteSelect.IdPaqueteProveedorTerrestre,
          idCiudad: cuidad.IdCiudad,
        };

        dispatch(crearCiudadPaqueteTerrestre(payload)).then((Response) => {
          switch (Response?.status) {
            case 500:
              ToastMessage.fire({
                icon: "error",
                title: "Ha habido un problema de conexión con el servidor",
              });
              break;
            case 400:
              ToastMessage.fire({
                icon: "warning",
                title: "<strong>Atención</strong>",
                text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
              });
              break;
            default:
              LimpiarForm();
              ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
              });

              dispatch(obtenerCiudadesPaqueteTerrestre({ idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre })).then((Response) => {
                setIsLoad(false);
              });
              break;
          }
          setIsLoad(false);
        });
      } else {
        ToastMessage.fire({
          icon: "warning",
          title: "<strong>Atención</strong>",
          text: "Este destino ya fue agregado.",
        });
      }
    }
  };

  const LimpiarForm = () => {
    setPais(InitialValuePais);
    setCuidad(InitialValueCiudad);
  };

  return (
    <Grid container className={classes.containerSpacing}>
      <Grid item xs={6}>
        <TablaRegistro  idPaquete={paqueteSelect.IdPaqueteProveedorTerrestre} />
      </Grid>
      <Grid item xs={6}>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12}>
            <AutoInputPaises
              label="Pais de origen"
              name="pais"
              target={pais}
              setTarget={setPais}
            />
          </Grid>
          <Grid item xs={12}>
            <AutoInputCuidades
              label="Ciudad de origen"
              name="ciudad"
              target={cuidad}
              setTarget={setCuidad}
              CodigoPais={pais.Codigo}
            />
          </Grid>
          <Grid item xs={12} className={classes.modalBotonesCenter}>
            <Button
              onClick={onGuardar}
              variant="contained"
              color="primary"
              className={classes.modalBoton}
              disabled={cuidad.IdCiudad > 0 ? false : true}
            >
              Agregar
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </Grid>
  );
};
export default Destinos;
